/* eslint no-param-reassign: 0 */
import base64js from 'base64-js';
import { TextEncoder } from 'text-encoding';
import { createMask } from 'imask';
import moment from 'moment-timezone';
import decode from 'jwt-decode';

export default {
  getURLSlug() {
    const hostName = window.location.hostname;
    const pathName = window.location.pathname;
    const envBaseHost = window.appConfig.BASE_URL;
    const hosts = envBaseHost ? envBaseHost.split(',') : [''];
    let isValidHostname = false;
    hosts.forEach((host) => {
      if (hostName.indexOf(host) !== -1) {
        isValidHostname = true;
      }
    });
    // if (hostName.indexOf(window.appConfig.BASE_HOST) !== -1) {
    if (isValidHostname) {
      const domainComponents = pathName
        .split('/')
        .filter(comp => comp !== '');
      if (domainComponents.length > 0) {
        return domainComponents[0];
      }
    }
    return '';
  },
  getProvinceList() {
    return [
      'กรุงเทพมหานคร',
      'กระบี่',
      'กาญจนบุรี',
      'กาฬสินธุ์',
      'กำแพงเพชร',
      'ขอนแก่น',
      'จันทบุรี',
      'ฉะเชิงเทรา',
      'ชลบุรี',
      'ชัยนาท',
      'ชัยภูมิ',
      'ชุมพร',
      'เชียงราย',
      'เชียงใหม่',
      'ตรัง',
      'ตราด',
      'ตาก',
      'นครนายก',
      'นครปฐม',
      'นครพนม',
      'นครราชสีมา',
      'นครศรีธรรมราช',
      'นครสวรรค์',
      'นนทบุรี',
      'นราธิวาส',
      'น่าน',
      'บึงกาฬ',
      'บุรีรัมย์',
      'ปทุมธานี',
      'ประจวบคีรีขันธ์',
      'ปราจีนบุรี',
      'ปัตตานี',
      'พระนครศรีอยุธยา',
      'พังงา',
      'พัทลุง',
      'พิจิตร',
      'พิษณุโลก',
      'เพชรบุรี',
      'เพชรบูรณ์',
      'แพร่',
      'พะเยา',
      'ภูเก็ต',
      'มหาสารคาม',
      'มุกดาหาร',
      'แม่ฮ่องสอน',
      'ยะลา',
      'ยโสธร',
      'ร้อยเอ็ด',
      'ระนอง',
      'ระยอง',
      'ราชบุรี',
      'ลพบุรี',
      'ลำปาง',
      'ลำพูน',
      'เลย',
      'ศรีสะเกษ',
      'สกลนคร',
      'สงขลา',
      'สตูล',
      'สมุทรปราการ',
      'สมุทรสงคราม',
      'สมุทรสาคร',
      'สระแก้ว',
      'สระบุรี',
      'สิงห์บุรี',
      'สุโขทัย',
      'สุพรรณบุรี',
      'สุราษฎร์ธานี',
      'สุรินทร์',
      'หนองคาย',
      'หนองบัวลำภู',
      'อ่างทอง',
      'อุดรธานี',
      'อุทัยธานี',
      'อุตรดิตถ์',
      'อุบลราชธานี',
      'อำนาจเจริญ',
    ];
  },
  base64Encode(str, encoding = 'utf-8') {
    const bytes = new TextEncoder(encoding).encode(str);
    return base64js.fromByteArray(bytes);
  },
  base64Decode(str, encoding = 'utf-8') {
    const bytes = base64js.toByteArray(str);
    return new TextEncoder(encoding).decode(bytes);
  },
  event(name) {
    const evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
    return evt;
  },
  getMaskValue(value, maskOptions) {
    const mask = createMask(maskOptions);
    return mask.resolve(value.toString());
  },
  getUnmaskValue(value, maskOptions) {
    const mask = createMask(maskOptions);
    mask.resolve(value.toString());
    return mask.unmaskedValue;
  },
  handleInput(evt, refs, refName, mask, maskName) {
    if (!evt.isTrusted) return; // avoid infinite loop
    if (typeof refs[refName] === 'undefined') {
      return;
    }
    const el = evt.target;
    /* other properties to try to differentiate InputEvent of Event (custom)
     InputEvent (native)
       cancelable: false
       isTrusted: true
       composed: true
       isComposing: false
       which: 0
     Event (custom)
       cancelable: true
       isTrusted: false
     */
    // by default, keep cursor at same position as before the mask
    let position = el.selectionEnd;
    // save the character just inserted
    const lastCharPosition = position - 1;
    const digit = el.value[lastCharPosition];
    let maskOptions = mask[maskName];
    if (typeof maskOptions.mask === 'undefined') {
      maskOptions = {
        mask: mask[maskName],
      };
    }
    const originalValue = this.getUnmaskValue(el.value, maskOptions);
    const maskValue = this.getMaskValue(originalValue, maskOptions);
    el.value = maskValue;
    let midx = position - 1;
    while (position < maskValue.length && maskValue.charAt(midx) !== digit) {
      position += 1;
      midx = position - 1;
    }
    if (el === document.activeElement) {
      el.setSelectionRange(position, position);
      setTimeout(() => {
        el.setSelectionRange(position, position);
      }, 0);
    }
    el.dispatchEvent(this.event('input'));
  },
  getTokenExpirationDate(token) {
    if (token === null) return null;
    try {
      const decoded = decode(token);
      if (!decoded.exp) {
        return null;
      }
      return moment(decoded.exp, 'X').tz(process.env.DEFAULT_TZ);
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  getTokenCompanyId(token) {
    if (token === null) return null;
    try {
      const decoded = decode(token);
      if (!decoded.company_id) {
        return null;
      }
      return decoded.company_id;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  isTokenExpired(token) {
    const date = this.getTokenExpirationDate(token);
    if (date === null) {
      return false;
    }
    return date.diff(moment().tz(process.env.DEFAULT_TZ)) <= 0;
  },
  getCurrentBaseHost() {
    const hostName = window.location.hostname;
    const envBaseHost = window.appConfig.BASE_HOST;
    const hosts = envBaseHost ? envBaseHost.split(',') : [''];
    let currentHostName = '';
    hosts.forEach((host) => {
      if (hostName.indexOf(host) !== -1) {
        currentHostName = host;
      }
    });
    return currentHostName;
  },
};



// WEBPACK FOOTER //
// ./src/libs/helpers.js